import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    cacheKey: String,
    startDate: String,
    endDate: String,
  };

  boundTurboSubmitEnd(event) {
    const action = event.target?.getAttribute?.("action");
    const responseUrl = event.detail?.fetchResponse?.response?.url;
    if (
      !event.detail?.success ||
      !action?.includes("/educator_home_page/preferences/update_") ||
      !responseUrl ||
      typeof Turbo === "undefined" ||
      typeof Turbo.visit !== "function"
    ) {
      return;
    }

    const redirectedUrl = new URL(responseUrl, window.location.origin);
    const currentUrl = new URL(window.location.href);
    if (
      redirectedUrl.pathname !== currentUrl.pathname ||
      redirectedUrl.search !== currentUrl.search
    ) {
      return;
    }

    const scrollX = window.scrollX;
    const scrollY = window.scrollY;
    const restoreScroll = () => window.scrollTo(scrollX, scrollY);
    document.addEventListener("turbo:load", restoreScroll, { once: true });
    Turbo.visit(currentUrl.href, { action: "replace" });
  }

  connect() {
    const root = this.element.closest(
      "[data-controller~='educator-home-page--tabs']",
    );
    if (!root) {
      return;
    }

    root.dataset.educatorHomeStartDate = this.startDateValue;
    root.dataset.educatorHomeEndDate = this.endDateValue;
    this._boundTurboSubmitEnd = this.boundTurboSubmitEnd.bind(this);
    document.addEventListener("turbo:submit-end", this._boundTurboSubmitEnd);

    const tabsController =
      this.application.getControllerForElementAndIdentifier(
        root,
        "educator-home-page--tabs",
      );
    if (!tabsController) {
      return;
    }

    if (tabsController.cacheKeyValue === this.cacheKeyValue) {
      tabsController.frameTargets.forEach((frame) => {
        if (frame.dataset.cacheKey !== this.cacheKeyValue) {
          this.refreshFrameMetadata(frame);
        }
      });
      return;
    }

    const reloadToken = String(
      Number(root.dataset.filtersRuntimeReloadToken || 0) + 1,
    );
    root.dataset.filtersRuntimeReloadToken = reloadToken;

    tabsController.cacheKeyValue = this.cacheKeyValue;
    tabsController.frameTargets.forEach((frame) =>
      this.refreshFrameMetadata(frame),
    );

    const activeFrame = tabsController.frameForTabKey?.(
      tabsController.activeTabValue,
    );
    if (!activeFrame) return;

    const tokenAtSchedule = reloadToken;
    requestAnimationFrame(() => {
      if (root.dataset.filtersRuntimeReloadToken !== tokenAtSchedule) return;

      tabsController
        .loadFrame(activeFrame, { userInitiated: true, showLoading: true })
        .catch(() => {})
    })
  }

  disconnect() {
    if (this._boundTurboSubmitEnd) {
      document.removeEventListener("turbo:submit-end", this._boundTurboSubmitEnd)
    }
  }

  refreshFrameMetadata(frame) {
    frame.dataset.cacheKey = this.cacheKeyValue;
    frame.dataset.loaded = "false";

    if (!frame.dataset.preloadUrl) {
      return;
    }

    try {
      const url = new URL(frame.dataset.preloadUrl, window.location.origin);
      url.searchParams.set("cache_key", this.cacheKeyValue);
      frame.dataset.preloadUrl = `${url.pathname}${url.search}`;
    } catch (_error) {
      // ponytail: malformed preload urls stay as-is; frame reload skipped next
    }
  }

}
